var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Allowed platforms")]),
      _c(
        "md-layout",
        [
          _c(
            "md-layout",
            { attrs: { "md-flex": "50" } },
            [
              _c(
                "md-switch",
                {
                  staticClass: "md-primary",
                  model: {
                    value: _vm.entity.platforms.desktop,
                    callback: function($$v) {
                      _vm.$set(_vm.entity.platforms, "desktop", $$v)
                    },
                    expression: "entity.platforms.desktop"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "switch-label" },
                    [
                      _c("md-icon", {
                        attrs: { "md-iconset": "fa fa-desktop" }
                      }),
                      _c("span", [_vm._v("Desktop")])
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "md-layout",
            { attrs: { "md-flex": "50" } },
            [
              _c(
                "md-switch",
                {
                  staticClass: "md-primary",
                  model: {
                    value: _vm.entity.platforms.tablet,
                    callback: function($$v) {
                      _vm.$set(_vm.entity.platforms, "tablet", $$v)
                    },
                    expression: "entity.platforms.tablet"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "switch-label" },
                    [
                      _c("md-icon", {
                        attrs: { "md-iconset": "fa fa-tablet-alt" }
                      }),
                      _c("span", [_vm._v("Tablet")])
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "md-layout",
        [
          _c(
            "md-layout",
            { attrs: { "md-flex": "50" } },
            [
              _c(
                "md-switch",
                {
                  staticClass: "md-primary",
                  model: {
                    value: _vm.entity.platforms.mobile_web,
                    callback: function($$v) {
                      _vm.$set(_vm.entity.platforms, "mobile_web", $$v)
                    },
                    expression: "entity.platforms.mobile_web"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "switch-label" },
                    [
                      _c("md-icon", {
                        staticClass: "rotated",
                        attrs: { "md-iconset": "fa fa-mobile-alt" }
                      }),
                      _c("span", [_vm._v("Mobile Web")])
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "md-layout",
            { attrs: { "md-flex": "50" } },
            [
              _c(
                "md-switch",
                {
                  staticClass: "md-primary",
                  model: {
                    value: _vm.entity.platforms.mobile_app,
                    callback: function($$v) {
                      _vm.$set(_vm.entity.platforms, "mobile_app", $$v)
                    },
                    expression: "entity.platforms.mobile_app"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "switch-label" },
                    [
                      _c("md-icon", {
                        attrs: { "md-iconset": "fa fa-mobile-alt" }
                      }),
                      _c("span", [_vm._v("Mobile App")])
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "md-layout",
        [
          _c(
            "md-layout",
            { attrs: { "md-flex": "50" } },
            [
              _c(
                "md-switch",
                {
                  staticClass: "md-primary",
                  model: {
                    value: _vm.entity.platforms.connectedtv,
                    callback: function($$v) {
                      _vm.$set(_vm.entity.platforms, "connectedtv", $$v)
                    },
                    expression: "entity.platforms.connectedtv"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "switch-label" },
                    [
                      _c("md-icon", { attrs: { "md-iconset": "fa fa-tv" } }),
                      _c("span", [_vm._v("ConnectedTV")])
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "md-layout",
        {
          staticClass: "platforms-info",
          attrs: { "md-flex": "100", "md-align": "center" }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showPlatformsInfo,
                  expression: "showPlatformsInfo"
                }
              ]
            },
            [_vm._v("Player only available on selected platforms")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09afccac", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09afccac","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/PlatformsForm.vue
// module id = 767
// module chunks = 0